export const getSourcesVars = {}
